import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAllDealsController = async () => {
  /**
   * input: null
   * output: All deals array
   * description: get all deals / get documents
   */

  try {
    const dealsCollection = collection(db, "deals");
    const q = query(
      dealsCollection,
      where("bid", "==", getLocalStorageItem("bid"))
    );
    const dealSnapshot = await getDocs(q);
    const dealsData = [];
    dealSnapshot.forEach((deal) =>
      dealsData.push({ id: deal.id, ...deal.data() })
    );
    return dealsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllDealsController;
